import {throwError as observableThrowError,  Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

export class ServiceBase {
	url: string = 'api';
	public handleError(error: HttpErrorResponse) {
		// in a real world app, we may send the server to some remote logging infrastructure
		// instead of just logging it to the console
		console.error(error);
		return observableThrowError(error.error || 'Server error');
	}
}
